export default "__VITE_ASSET__C1zQO$vq__"